
import GridData from '@/sag-core/base/GridDataBase.js'
export default new GridData(
    {
        name: 'DGridData',
        // label 欄位顯示名稱，field 資料表欄位名稱
        columns: [
            {
                label: '序列',
                field: 'SerNum',
            },
            {
                label: 'BOM階層', 
                field: 'BomLevel'
            },
            {
                label: '產品品號',
                field: 'ProdNo'
            },
            {
                label: '製程代號',
                field: 'ProcessCode'
            },
            {
                label: '製程名稱',
                field: 'ProcessName'
            },
            {
                label: '錯誤類型',
                field: 'ErrorType'
            },
            {
                label: '錯誤訊息',
                field: 'ErrorMessage'
            }
        ],
        columnsConfig: {
            tdClass: 'align-middle',
            filterOptions: {
                enabled: false,
                placeholder: `Search`
            }
        }
    }
)